import React, { useEffect, useRef } from "react";
import { decode } from "blurhash";

// Renders a blurhash placeholder to a canvas. Used when the real image
// URL isn't available (private image viewed by a non-owner) or while
// the real image is loading.
export default function BlurhashImage({ hash, width = 32, height = 32, style }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!hash || !canvasRef.current) return;
    try {
      const pixels = decode(hash, width, height);
      const ctx = canvasRef.current.getContext("2d");
      const imageData = ctx.createImageData(width, height);
      imageData.data.set(pixels);
      ctx.putImageData(imageData, 0, 0);
    } catch (e) {
      // Invalid blurhash — silently fall back to empty canvas
    }
  }, [hash, width, height]);

  return (
    <canvas
      ref={canvasRef}
      width={width}
      height={height}
      style={{ width: "100%", height: "100%", display: "block", ...style }}
    />
  );
}
